import "./workspace.e021bdc9.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec702"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec702"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("d1EmY", function(module, exports) {
module.exports = import.meta.resolve("fLoJN");

});

parcelRequire("bgeJJ");
parcelRequire("l2CVb");
parcelRequire("fvzOd");

var $jJTNo = parcelRequire("jJTNo");

var $d1EmY = parcelRequire("d1EmY");
var $42db33f79d8166fb$exports = {};
$42db33f79d8166fb$exports = import.meta.resolve("dvuPu");


class $d9dfcd0ad7367f09$var$PicCarousel extends HTMLElement {
    constructor(){
        super();
        this.shadow = this.attachShadow({
            mode: 'open'
        });
        this._active = 0;
        this._autoplayTimer = null;
        this._autoplayMs = 0;
        this._navLock = false;
    }
    static get observedAttributes() {
        return [
            'autoplay'
        ];
    }
    get autoplay() {
        return this._autoplayMs;
    }
    set autoplay(v) {
        this._autoplayMs = this._parseAutoplay(v);
        this._restartAutoplay();
    }
    attributeChangedCallback(name, _old, val) {
        if (name === 'autoplay') {
            this._autoplayMs = this._parseAutoplay(val);
            this._restartAutoplay();
        }
    }
    connectedCallback() {
        this._autoplayMs = this._parseAutoplay(this.getAttribute('autoplay'));
        this.render();
        this._afterRender();
        // kick off after layout settles
        queueMicrotask(()=>this._restartAutoplay());
    }
    disconnectedCallback() {
        this._stopAutoplay();
        this._io?.disconnect();
        this._ro?.disconnect();
    }
    _template() {
        return (0, $jJTNo.html)`
      <link href="${$d1EmY}" rel="stylesheet" />
      <link href="${$42db33f79d8166fb$exports}" rel="stylesheet" />
      <div class="pc-wrap">
        <button
          class="pc-btn pc-prev"
          type="button"
          aria-label="Previous slide"
        >
          ‹
        </button>
        <button class="pc-btn pc-next" type="button" aria-label="Next slide">
          ›
        </button>

        <div class="pc-track" part="track">
          <slot id="slotImgs"></slot>
        </div>

        <div class="pc-fade" aria-hidden="true"></div>
        <div class="pc-dots" role="tablist" aria-label="Slide indicators"></div>
      </div>
    `;
    }
    render() {
        (0, $jJTNo.render)(this._template(), this.shadow);
    }
    _afterRender() {
        this.$track = this.shadow.querySelector('.pc-track');
        this.$prev = this.shadow.querySelector('.pc-prev');
        this.$next = this.shadow.querySelector('.pc-next');
        this.$dots = this.shadow.querySelector('.pc-dots');
        this.$slot = this.shadow.querySelector('#slotImgs');
        const build = ()=>{
            const slides = this._slidesEls();
            // Build dots
            this.$dots.innerHTML = '';
            slides.forEach((_, i)=>{
                const d = document.createElement('button');
                d.className = 'pc-dot';
                d.type = 'button';
                d.setAttribute('role', 'tab');
                d.setAttribute('aria-label', `Go to slide ${i + 1}`);
                d.addEventListener('click', ()=>this.goTo(i));
                this.$dots.appendChild(d);
            });
            // Observe visibility to update active index
            this._observeSlides();
            this._setActive(0, false);
        };
        this.$slot.addEventListener('slotchange', build);
        build();
        this.$prev.addEventListener('click', ()=>this.prev());
        this.$next.addEventListener('click', ()=>this.next());
        this.shadow.addEventListener('keydown', (e)=>{
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                this.prev();
            }
            if (e.key === 'ArrowRight') {
                e.preventDefault();
                this.next();
            }
        });
        this._ro?.disconnect();
        this._ro = new ResizeObserver(()=>this._snapToActive());
        this._ro.observe(this.$track);
        this._restartAutoplay();
    }
    _slidesEls() {
        // Slotted nodes are laid out as children of track for flex purposes
        const assigned = this.shadow.querySelector('#slotImgs').assignedElements({
            flatten: true
        });
        // Allow <img> and generic slide containers
        return assigned.filter((el)=>el.tagName === 'IMG' || el.classList.contains('pc-slide'));
    }
    _isAutoLocked(idx = this._active) {
        const slides = this._slidesEls();
        const el = slides[idx];
        return el?.hasAttribute('data-lock-autoplay');
    }
    _observeSlides() {
        this._io?.disconnect();
        const slides = this._slidesEls();
        if (!slides.length) return;
        const opts = {
            root: this.$track,
            threshold: 0.6
        };
        this._io = new IntersectionObserver((entries)=>{
            if (this._navLock) return; // Don't re-pick active mid-jump
            const visible = entries.filter((e)=>e.isIntersecting).sort((a, b)=>b.intersectionRatio - a.intersectionRatio)[0];
            if (visible) {
                const idx = this._slidesEls().indexOf(visible.target);
                if (idx !== -1) this._setActive(idx, false);
            }
        }, opts);
        slides.forEach((el)=>this._io.observe(el));
    }
    _setActive(i, smooth = true) {
        const slides = this._slidesEls();
        if (!slides.length) return;
        const len = slides.length;
        const prev = this._active;
        const raw = i;
        const target = (i + len) % len;
        this._active = target;
        Array.from(this.$dots.children).forEach((d, k)=>{
            d.setAttribute('aria-current', k === target ? 'true' : 'false');
        });
        slides.forEach((el, k)=>{
            el.setAttribute('data-active', k === target ? 'true' : 'false');
            el.setAttribute('tabindex', k === target ? '0' : '-1');
        });
        if (this._isAutoLocked(target)) this._stopAutoplay();
        // Detect wrap (len-1 -> 0 or 0 -> len-1) OR multi-hop jump (distance > 1)
        const wrappedForward = prev === len - 1 && raw >= len;
        const wrappedBackward = prev === 0 && raw < 0;
        const isWrap = wrappedForward || wrappedBackward;
        const distCW = (target - prev + len) % len; // clockwise steps
        const distCCW = (prev - target + len) % len; // counter-clockwise steps
        const multiHop = Math.min(distCW, distCCW) > 1;
        if (isWrap || multiHop) {
            // Hard jump: disable snap + IO updates during programmatic scroll
            this._navLock = true;
            const track = this.$track;
            const prevSnap = track.style.scrollSnapType;
            const prevBeh = track.style.scrollBehavior;
            track.style.scrollSnapType = 'none';
            track.style.scrollBehavior = 'auto';
            // Calculate scroll position within the track container only
            const trackRect = track.getBoundingClientRect();
            const slideRect = slides[target].getBoundingClientRect();
            const scrollLeft = track.scrollLeft + (slideRect.left - trackRect.left) - (trackRect.width - slideRect.width) / 2;
            track.scrollLeft = scrollLeft;
            requestAnimationFrame(()=>{
                track.style.scrollSnapType = prevSnap || 'x mandatory';
                track.style.scrollBehavior = prevBeh || 'smooth';
                this._navLock = false;
            });
            return;
        }
        // Normal in-bounds move (single step) - scroll within track only
        const track = this.$track;
        const trackRect = track.getBoundingClientRect();
        const slideRect = slides[target].getBoundingClientRect();
        const scrollLeft = track.scrollLeft + (slideRect.left - trackRect.left) - (trackRect.width - slideRect.width) / 2;
        if (!smooth) track.style.scrollBehavior = 'auto';
        track.scrollLeft = scrollLeft;
        if (!smooth) queueMicrotask(()=>track.style.scrollBehavior = 'smooth');
    }
    _parseAutoplay(val) {
        if (val == null) return 0;
        if (val === '' || val === 'true') return 8000;
        if (/^\d+\s*ms$/i.test(val)) return parseInt(val, 10);
        if (/^\d+(\.\d+)?\s*s$/i.test(val)) return Math.round(parseFloat(val) * 1000);
        const n = Number(val);
        if (!Number.isFinite(n)) return 0;
        return n > 0 && n <= 50 ? n * 1000 : n;
    }
    _snapToActive() {
        this._setActive(this._active, false);
    }
    next() {
        this._setActive(this._active + 1);
        this._restartAutoplay(true);
    }
    prev() {
        this._setActive(this._active - 1);
        this._restartAutoplay(true);
    }
    goTo(i) {
        this._setActive(i);
        this._restartAutoplay(true);
    }
    _restartAutoplay(userNav = false) {
        this._stopAutoplay();
        if (this._isAutoLocked()) return;
        if (this._autoplayMs > 0) {
            const delay = userNav ? Math.min(this._autoplayMs, 4000) : this._autoplayMs;
            this._autoplayTimer = setTimeout(()=>{
                this.next();
                this._restartAutoplay();
            }, delay);
        }
    }
    _stopAutoplay() {
        if (this._autoplayTimer) clearTimeout(this._autoplayTimer);
        this._autoplayTimer = null;
    }
}
customElements.define('pic-carousel', $d9dfcd0ad7367f09$var$PicCarousel);


document.addEventListener('DOMContentLoaded', function() {
    const bubbles = document.querySelectorAll('.subjects li');
    let lastIndex = -1;
    setInterval(()=>{
        if (!bubbles.length) return;
        // Remove active from all
        bubbles.forEach((b)=>b.classList.remove('active'));
        // Pick a random bubble, not the same as last
        let idx;
        do idx = Math.floor(Math.random() * bubbles.length);
        while (idx === lastIndex && bubbles.length > 1);
        lastIndex = idx;
        const bubble = bubbles[idx];
        bubble.classList.add('active');
        // Remove after 1s unless hovered
        setTimeout(()=>{
            if (!bubble.matches(':hover')) bubble.classList.remove('active');
        }, 1000);
    }, 2000);
});
// ---- About page <-> <sign-up> bridge (no HTML changes) ----
/** Normalize helper */ const $43ade6939d20f76f$var$toValue = (txt)=>txt.trim().toLowerCase();
/** Wait until the custom element is defined & rendered once */ async function $43ade6939d20f76f$var$getSignUp() {
    await customElements.whenDefined('sign-up');
    const el = document.querySelector('sign-up');
    // Ensure it has rendered; its connectedCallback renders immediately,
    // but raf gives us a safe tick for shadow contents to exist.
    await new Promise((r)=>requestAnimationFrame(r));
    return el;
}
/** Click a bubble inside the component (optionally only if not already selected) */ function $43ade6939d20f76f$var$clickBubble(signUp, groupSelector, value, { ensureSelected: ensureSelected = false, toggle: toggle = false } = {}) {
    const root = signUp.shadowRoot;
    if (!root) return;
    const btn = root.querySelector(`${groupSelector} [data-value="${value}"]`);
    if (!btn) return;
    const isSelected = btn.classList.contains('selected');
    if (ensureSelected) {
        if (!isSelected) btn.click(); // add but don't remove on repeat
    } else if (toggle) btn.click(); // invert current state
    else // single-select groups behave fine with a direct click
    btn.click();
}
/** Open the slide-out via the component’s public method */ function $43ade6939d20f76f$var$openSignUp(signUp) {
    if (typeof signUp.open === 'function') signUp.open();
    else {
        // fallback: toggle the class in shadow (shouldn't be needed)
        const panel = signUp.shadowRoot?.getElementById('contact-slide-panel');
        panel?.classList.add('open');
    }
}
document.addEventListener('DOMContentLoaded', async ()=>{
    const signUp = await $43ade6939d20f76f$var$getSignUp();
    if (!signUp) return;
    const root = signUp.shadowRoot;
    // ——— 1) “Sign Up for Lessons!” button in the contact card
    const cardSignupBtn = document.getElementById('contact-card-signup');
    if (cardSignupBtn) cardSignupBtn.addEventListener('click', ()=>$43ade6939d20f76f$var$openSignUp(signUp));
    // ——— 2) Instruments & Subjects list -> study bubbles (MULTI-SELECT, additive)
    const instrumentItems = document.querySelectorAll('.subjects ul li');
    instrumentItems.forEach((item)=>{
        item.style.cursor = 'pointer';
        item.addEventListener('click', ()=>{
            const val = $43ade6939d20f76f$var$toValue(item.textContent);
            // Ensure it is selected (don’t toggle off if clicked twice on the page list)
            $43ade6939d20f76f$var$clickBubble(signUp, '.study-bubbles', val, {
                ensureSelected: true
            });
            $43ade6939d20f76f$var$openSignUp(signUp);
        });
    });
    // ——— 3) Rates grid -> length & recurrence bubbles (single-select)
    const rateBubbles = document.querySelectorAll('.rate-group p');
    rateBubbles.forEach((p)=>{
        p.style.cursor = 'pointer';
        p.addEventListener('click', function() {
            // Example text: "$60 — 30 min"  (em dash or hyphen)
            const txt = this.textContent;
            const match = txt.match(/[-—]\s*(.+)$/);
            if (match) {
                const length = match[1].trim(); // "30 min" | "45 min" | "60 min"
                $43ade6939d20f76f$var$clickBubble(signUp, '.length-bubbles', length);
            }
            // Determine recurrence from enclosing group header
            const group = this.closest('.rate-group');
            const heading = group?.querySelector('h3')?.textContent || '';
            let recurrence = '';
            if (/weekly/i.test(heading)) recurrence = 'Weekly';
            else if (/single/i.test(heading)) recurrence = 'Single';
            if (recurrence) $43ade6939d20f76f$var$clickBubble(signUp, '.recurrence-bubbles', recurrence);
            $43ade6939d20f76f$var$openSignUp(signUp);
        });
    });
    // ——— 4) Day pills -> days bubbles (MULTI-SELECT, toggle)
    const dayPills = document.querySelectorAll('.day-pill');
    dayPills.forEach((pill)=>{
        pill.addEventListener('click', function() {
            const dayValue = this.dataset.day; // "Monday", etc.
            // Let the component own the pill’s active state via its mirror.
            // We toggle selection by clicking the shadow bubble; it will mirror .active back to this pill.
            $43ade6939d20f76f$var$clickBubble(signUp, '.days-bubbles', dayValue, {
                toggle: true
            });
            $43ade6939d20f76f$var$openSignUp(signUp);
        });
    });
    // ——— 5) Keep page toggle opening behavior if user hits the floating tab
    // (Not strictly required; component handles its own toggle, but this is harmless.)
    const toggleBtn = root?.getElementById('contact-slide-toggle');
    toggleBtn?.addEventListener('click', ()=>$43ade6939d20f76f$var$openSignUp(signUp));
});


//# sourceMappingURL=about.7db3b295.js.map
